function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "step3",
  transform: "translate(-846 -94)"
}, React.createElement("g", {
  id: "border",
  transform: "translate(846 95)",
  fill: "none",
  stroke: "#303133",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}, React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  stroke: "none"
}), React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11.25,
  fill: "none"
})), React.createElement("text", {
  id: "_4",
  "data-name": 4,
  transform: "translate(857.5 113)",
  fill: "#303133",
  fontSize: 16,
  fontFamily: "NotoSansTC-Regular, Noto Sans TC"
}, React.createElement("tspan", {
  x: -4.44,
  y: 0
}, "3")));

var SvgIconStep3Active = function SvgIconStep3Active(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconStep3Active, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_step3_active.3a4a0ec2.svg";
export { ForwardRef as ReactComponent };